import { isPlatformBrowser } from '@angular/common';
import {
  EnvironmentProviders,
  inject,
  PLATFORM_ID,
  provideAppInitializer,
} from '@angular/core';
import { getRuntimeWindow } from '@imagise/shared';
import { ErrorReportingService } from './error-reporting.service';

/**
 * Registers global browser error listeners (`error` and `unhandledrejection`)
 * that feed the reporting pipeline as non-fatal incidents. No-op during SSR.
 */
export function provideBrowserErrorListeners(): EnvironmentProviders {
  return provideAppInitializer(() => {
    if (!isPlatformBrowser(inject(PLATFORM_ID))) {
      return;
    }

    const reporting = inject(ErrorReportingService);
    const runtimeWindow = getRuntimeWindow();

    runtimeWindow.addEventListener('error', (event: ErrorEvent) => {
      reporting.report(event.error ?? event.message, 'non-fatal');
    });

    runtimeWindow.addEventListener(
      'unhandledrejection',
      (event: PromiseRejectionEvent) => {
        reporting.report(event.reason, 'non-fatal');
      }
    );
  });
}
